module.exports = __webpack_public_path__ + "fonts/Manrope-500-cyrillic-ext7.64f66ba.woff2";